<link type="text/css" href="https://cdn.jsdelivr.net/npm/vuetify@2.2.28/dist/vuetify.min.css"/>
<template>
    <div class="component-container ">
        <div class="page-resa d-flex align-items-center col-lg-6 col-md-8 g-column mx-auto" style=" padding: 0px">
            <p data-v-57d0aafd="" class="fw-bold fs-2 text-center mb-3">Disponibilités</p>
            <div
                class="time-slots"
                style="height: auto; margin: 0px; margin-bottom: 25px; cursor: pointer;max-width: 175px"

                :style="[showBtn ?  {'color': 'hsl(var(--p))','border-color':'hsl(var(--p))'} :''  ]"
                v-on:click="setPasPref(-1);setPracti(NULL)"
            >Pas de préference


            </div>
            <p data-v-57d0aafd="" class="fw-bold fs-2 text-center mb-3">Ou</p>

            <v-app id="inspire" style="width: 50%;min-width: 300px;flex-direction: column">
                            <v-select @change="valuePracti=1;showBtn=true" v-model="currentPracti" class="form-control"
                                      style="border-radius: 19px;padding:10px;color:hsl(var(--p));border-color:hsl(var(--p))"
                                      :items="ListeStaffs"
                                      label="choisissez votre praticien(ne) préféré(e)"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <img class="imgStaff" :src="item.image">{{ item.first_name }}
                                </template>
                                <template v-slot:item="{ item }">
                                    <img class="imgStaff" :src="item.image">{{ item.first_name }}
                                </template>
                            </v-select>

            </v-app>
            <div v-if="staffs.length>0">

            </div>
            <p v-if="valuePracti==1" style="color:#707070;">Vous avez choisi :
                {{ currentPracti ? currentPracti.first_name : '' }}</p>
            <p v-else style="color:#707070;">Vous avez choisi : pas de preference</p>
            <input type="hidden" id="practi" name="practi" :value="JSON.stringify(this.currentPracti)"/>
            <input type="hidden" id="valuePracti" name="valuePracti" :value="valuePracti"/>
            <button v-if="showBtn" type="submit" class="time-slots">Continuer</button>


        </div>
    </div>
</template>

<script type="text/javascript" src="https://cdn.jsdelivr.net/npm/vuetify@2.2.28/dist/vuetify.min.js"/>
<script>
export default {
    name: 'Staff',
    props: ['staffs'],
    data: () => ({
        color: '#FF00FF',
        currentPracti: null,
        showBtn: false,
        valuePracti: 0,
        ListeStaffs: []
    }),
    mounted() {
        this.getListeStaff();
    },
    methods: {
        setPracti(e) {
            if (this.currentPracti == e)
                this.currentPracti = null

            else
                this.currentPracti = e;


            this.showBtn = true;
        },


        setPasPref(e) {
            this.valuePracti = -1;
            this.showBtn = true;
        },
        getListeStaff() {
            let getUrl = window.location;
            let baseUrl = getUrl.protocol + "//" + getUrl.host;

            this.staffs.forEach((element, index) => {
if(element){
                let image = (typeof(element.image) == 'undefined' || element.image=== null ) ? baseUrl + '/media/default.jpg' : element.image;

                this.ListeStaffs.push({
                    'first_name': element.first_name,
                    'last_name': element.last_name,
                    'image': image,
                    'id':element.id
                });
}
            });
        }
    }
}

</script>
<style scoped>
input[type=text]{
    border:none !important;
    padding:0 !important;
}
.tooltip {
    opacity: 1 !important;
    position: relative;
    display: inline-block; /* If you want dots under the hoverable text */
}
.imgStaff {
    height: 25px !important;
    border-radius: 50%;
    margin-right: 7px;
}

.v-menu__content.theme--light.menuable__content__active {
    position: relative;
}

/* Tooltip text */
.tooltip .tooltiptext {
    visibility: hidden;
    background-color: #f1f1f1;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;
    top: -5px;
    left: 105%;
    width: 100%;
    /* -webkit-box-shadow: 7px 6px 19px 0px #000000;
box-shadow: 7px 6px 19px 0px #000000; */

    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
    visibility: visible;
}

div:deep(.v-application--wrap)  {
    min-height: initial;
}

.component-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.page-resa {
    padding-bottom: 10rem;
    width: 100%;
    gap: 20px;
    display: flex;
}

.sub-title-resa {
    font-size: 1.5rem;
    font-weight: 700;
}

.description-resa {
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.description-resa li {
    color: gray;
    font-size: 12px;
    list-style-position: inside;
}

.resa-col-1 {
    flex: 3;
}

.resa-col-2-3 {
    display: flex;
    flex: 2;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

@media (min-width: 2000px) {
    .resa-col-2-3 {
        flex-direction: row;
    }
}

.resa-col-2,
.resa-col-3 {
    max-width: 350px;
}

@media (max-width: 1279px) {
    .page-resa {
        flex-direction: column;
    }

    .resa-col-1,
    .resa-col-2,
    .resa-col-3 {
        width: 100%;
    }

    .resa-col-2,
    .resa-col-3 {
        max-width: fit-content;
        min-width: 100%;
    }
}

.title-resa {
    font-family: 'Playfair Display';
    color: black;
}

.calendar-container {
    width: 35%;
}

.titleSlot {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
}
.primary--text{
    color:hsl(var(--p)) !important;
}
.slot-container {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
}

.slot-time {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 1rem;
}

.card-slot {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid black;
    width: 12rem;
    padding: 1rem 0;
    margin: 1rem 0;
    transition: all 0.2s ease-in-out;
}

.card-slot:hover {
    background-color: black;
    color: #cca000;
}

.card-slot.active {
    background-color: black;
    color: #cca000;
}

.line-separator {
    border-left: 1px solid rgba(128, 128, 128, 0.772);
    height: auto;
    width: 1rem;
}

/*  */

.lds-ring {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 40px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 4px;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>

